import { atom, useAtom } from 'jotai';

const appShellAtom = atom(false);

export function useAppShell() {
  return useAtom(appShellAtom);
}
